var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "h-full"
  }, [_c('div', {
    staticClass: "member"
  }, [_vm.loading ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }) : _vm._e(), _c('div', {
    staticClass: "tree p-4"
  }, [_c('MemberTree', {
    on: {
      "onChange": _vm.onChangeTree,
      "onSearch": _vm.onSearch,
      "onChangeLoading": _vm.onChangeLoading
    }
  })], 1), _c('div', {
    staticClass: "member_content p-4"
  }, [_c('MemberList', {
    attrs: {
      "node": _vm.node,
      "searchValue": _vm.searchValue
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };